<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10" v-if="!userID">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.id') }}:</label>
                <div>
                    <el-input v-model="filterData.id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.firstname') }}:</label>
                <div>
                    <el-input v-model="filterData.firstname" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lastname') }}:</label>
                <div>
                    <el-input v-model="filterData.lastname" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.email') }}:</label>
                <div>
                    <el-input v-model="filterData.email" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.identificationNumber') }}:</label>
                <div>
                    <el-input v-model="filterData.identification_number" v-mask="{ mask:'99999999999', placeholder: '' }" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.mobilePhone') }}:</label>
                <div>
                    <el-input v-model="filterData.mobile_phone" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.birthDateMin') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['birth_date[min]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMinDate(date, 'birth_date[max]', false)" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.birthDateMax') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['birth_date[max]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMaxDate(date, 'birth_date[min]', false)" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.age') }}:</label>
                <div class="d-flex align-items-center">
                    <el-input v-model="filterData['age[min]']" :placeholder="$t('common.min')" oninput="value=value.replace(/[^0-9]/g,'')"/>
                    <span class="mx-2">-</span>
                    <el-input v-model="filterData['age[max]']" :placeholder="$t('common.max')" oninput="value=value.replace(/[^0-9]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.isAbroad') }}:</label>
                <div>
                    <el-select v-model="filterData.is_abroad" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('common.yes')"></el-option>
                        <el-option :value="false" :label="$t('common.no')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.state') }}:</label>
                <div>
                    <el-select v-model="filterData.state_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable @change="addressStateChanged">
                        <el-option v-for="(state, stateIndex) in stateWithCities" :key="stateIndex" :value="state.id" :label="state.name"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.city') }}:</label>
                <div>
                    <el-select v-model="filterData.city_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable :disabled="!filterData.state_id">
                        <el-option v-for="(city, cityIndex) in addressCities" :key="cityIndex" :value="city.id" :label="city.name"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.hasAddress') }}:</label>
                <div>
                    <el-select v-model="filterData.has_address" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('filters.ecommerce.user.hasAddressYes')"></el-option>
                        <el-option :value="false" :label="$t('filters.ecommerce.user.hasAddressNo')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="fs-6 fw-bold mb-2">{{ $t('filters.ecommerce.user.label') }}</label>
                <el-select v-model="filterData.labels" class="w-100" :placeholder="$t('common.chooseSelect')" filterable multiple>
                    <el-option v-for="(label, labelIndex) in labels" :key="labelIndex" :value="label.id" :label="label.name"></el-option>
                </el-select>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.createdAtMin') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['created_at[min]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="disabledCreatedMinDate" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.createdAtMax') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['created_at[max]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="disabledCreatedMaxDate" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.order') }}:</label>
                <div>
                    <el-select v-model="orderState" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option value="none" :label="$t('filters.ecommerce.user.noOrder')"></el-option>
                        <el-option value="first" :label="$t('filters.ecommerce.user.firstTimeBuyerYes')"></el-option>
                        <el-option value="repeat" :label="$t('filters.ecommerce.user.firstTimeBuyerNo')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.orderCount') }}:</label>
                <div class="d-flex align-items-center">
                    <el-input v-model="filterData['order_count[min]']" :placeholder="$t('common.min')" :disabled="noOrder" oninput="value=value.replace(/[^0-9]/g,'')"/>
                    <span class="mx-2">-</span>
                    <el-input v-model="filterData['order_count[max]']" :placeholder="$t('common.max')" :disabled="noOrder" oninput="value=value.replace(/[^0-9]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.orderStatus') }}:</label>
                <div>
                    <el-select v-model="filterData.order_status_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable multiple>
                        <el-option v-for="(status, statusIndex) in orderStatus" :key="statusIndex" :value="status.id" :label="status.name"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.totalSpent') }}:</label>
                <div class="d-flex align-items-center">
                    <el-input v-model="filterData['total_spent[min]']" :placeholder="$t('common.min')" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                    <span class="mx-2">-</span>
                    <el-input v-model="filterData['total_spent[max]']" :placeholder="$t('common.max')" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lastOrderMin') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['last_order[min]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMinDate(date, 'last_order[max]')" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lastOrderMax') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['last_order[max]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMaxDate(date, 'last_order[min]')" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.product') }}:</label>
                <div>
                    <el-select
                        class="w-100"
                        v-model="filterData.product_id"
                        filterable
                        clearable
                        multiple
                        remote
                        :remote-method="remoteSearchProduct"
                        :loading="product.loading"
                        :placeholder="$t('filters.ecommerce.user.searchHint')">
                        <el-option v-for="(item, itemIndex) in product.list" :key="itemIndex" :value="item.id" :label="translateTitle(item)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.productCategory') }}:</label>
                <div>
                    <el-select
                        class="w-100"
                        v-model="filterData.product_category_id"
                        filterable
                        clearable
                        multiple
                        remote
                        :remote-method="remoteSearchProductCategory"
                        :loading="productCategory.loading"
                        :placeholder="$t('filters.ecommerce.user.searchHint')">
                        <el-option v-for="(item, itemIndex) in productCategory.list" :key="itemIndex" :value="item.id" :label="translateTitle(item)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.couponCode') }}:</label>
                <div>
                    <el-input v-model="filterData.coupon_code" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.usageExpiring') }}:</label>
                <div>
                    <el-input v-model="filterData.usage_expiring" :placeholder="$t('filters.ecommerce.user.usageExpiringPlaceholder')" oninput="value=value.replace(/[^0-9]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lectureWatched') }}:</label>
                <div>
                    <el-select v-model="filterData.lecture_watched" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('filters.ecommerce.user.lectureWatchedYes')"></el-option>
                        <el-option :value="false" :label="$t('filters.ecommerce.user.lectureWatchedNo')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.watchingDuration') }}:</label>
                <div class="d-flex align-items-center">
                    <el-input v-model="watchingDurationMin" :placeholder="$t('common.min')" oninput="value=value.replace(/[^0-9]/g,'')"/>
                    <span class="mx-2">-</span>
                    <el-input v-model="watchingDurationMax" :placeholder="$t('common.max')" oninput="value=value.replace(/[^0-9]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.examParticipated') }}:</label>
                <div>
                    <el-select v-model="filterData.exam_participated" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('filters.ecommerce.user.examParticipatedYes')"></el-option>
                        <el-option :value="false" :label="$t('filters.ecommerce.user.examParticipatedNo')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.branchCourse') }}:</label>
                <div>
                    <el-select v-model="filterData.branch_course_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable multiple>
                        <el-option v-for="(branchCourse, branchCourseIndex) in branchCourses" :key="branchCourseIndex" :value="branchCourse.id" :label="branchCourseTitle(branchCourse)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lastLoginMin') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['last_login[min]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMinDate(date, 'last_login[max]')" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.lastLoginMax') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData['last_login[max]']" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="(date) => disabledRangeMaxDate(date, 'last_login[min]')" clearable></el-date-picker>
                </div>
            </div>
            <div class="mb-10" v-for="(element, elementIndex) in registerElements" :key="elementIndex">
                <label class="form-label fw-bold">{{ element.translate.title }}:</label>
                <div>
                    <el-input v-if="element.type.code == 'input'" v-model="filterData[element.input_name]" type="text"/>
                    <el-input v-if="element.type.code == 'textarea'" v-model="filterData[element.input_name]" type="textarea" rows="3" maxlength="512"/>
                    <el-select v-if="element.type.code == 'select'" v-model="filterData[element.input_name]" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable :multiple="element.options && element.options.multiple">
                        <el-option v-for="(item, itemIndex) in element.translate.items" :key="itemIndex" :value="item.val" :label="item.text"></el-option>
                    </el-select>
                    <el-select v-if="element.type.code == 'state'" v-model="filterData[element.input_name]" class="w-100" filterable @change="stateChanged(element.input_name)" :placeholder="$t('common.chooseSelect')" clearable :multiple="element.options && element.options.multiple">
                        <el-option v-for="(state, stateIndex) in stateWithCities" :key="stateIndex" :label="state.name" :value="state.name"></el-option>
                    </el-select>
                    <el-select v-if="element.type.code == 'city'" v-model="filterData[element.input_name]" class="w-100 citySelect" filterable :placeholder="$t('common.chooseSelect')" clearable :multiple="element.options && element.options.multiple" :data-inputName="element.input_name">
                        <el-option v-for="(city, cityIndex) in cities" :key="cityIndex" :label="city.name" :value="city.name"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.user.status') }}:</label>
                <div>
                    <el-select v-model="filterData.active" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('common.active')"></el-option>
                        <el-option :value="false" :label="$t('common.passive')"></el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            filterData: {},
            cities: [],
            addressCities: [],
            product: {
                loading: false,
                list: []
            },
            productCategory: {
                loading: false,
                list: []
            },
            searchTimers: {}
        }
    },
    computed: {
        userID() {
            return this.$route.query.userID;
        },
        registerElements() {
            return this.$store.state.system.setting.registerElement.table.data.map((element) => {
                element.translate = this.resolveDatum(element.translations, this.$root.defaultLanguage.id, 'language_id');
                return element;
            });
        },
        stateWithCities() {
            return this.$store.state.localization.country.state.table.data;
        },
        labels() {
            return this.$store.state.ecommerce.user.label.table.data;
        },
        orderStatus() {
            return this.$store.state.ecommerce.order.status.table.data;
        },
        branchCourses() {
            return this.$store.state.module.branchCourse.table.data;
        },
        watchingDurationMin: {
            get() {
                return this.secondToMinute(this.filterData['watching_duration[min]']);
            },
            set(value) {
                this.setMinuteAsSecond('watching_duration[min]', value);
            }
        },
        watchingDurationMax: {
            get() {
                return this.secondToMinute(this.filterData['watching_duration[max]']);
            },
            set(value) {
                this.setMinuteAsSecond('watching_duration[max]', value);
            }
        },
        noOrder() {
            let value = this.filterData['order_count[max]'];

            return value === 0 || value === '0';
        },
        orderState: {
            get() {
                if (this.noOrder) {
                    return 'none';
                }

                let firstTimeBuyer = this.filterData.first_time_buyer;

                if (firstTimeBuyer === true) {
                    return 'first';
                }

                if (firstTimeBuyer === false) {
                    return 'repeat';
                }

                return undefined;
            },
            set(value) {
                delete this.filterData.first_time_buyer;
                delete this.filterData['order_count[max]'];

                if (value === 'none') {
                    delete this.filterData['order_count[min]'];
                    this.filterData['order_count[max]'] = 0;
                } else if (value === 'first' || value === 'repeat') {
                    this.filterData.first_time_buyer = (value === 'first');
                }
            }
        }
    },
    mounted() {
        if (this.userID) {
            this.filterData.id = this.userID;
        }

        this.$store.dispatch('system/setting/registerElement/get', {
            page: {pageSize: 9999}
        });

        this.$store.dispatch('localization/country/state/get', {
            page: {pageSize: 9999},
            filterData: {
                country_id: 1
            }
        });

        this.$store.dispatch('ecommerce/user/label/get', {
            page: {
                pageSize: 9999
            }
        });

        this.$store.dispatch('ecommerce/order/status/get', {
            page: {pageSize: 9999}
        });

        this.$store.dispatch('module/branchCourse/get', {
            page: {pageSize: 9999}
        });
    },
    methods: {
        onReset() {
            this.filterData = {};
            this.addressCities = [];
            this.product.list = [];
            this.productCategory.list = [];
            this.onFilter();
        },
        onFilter() {
            let filterData = this.cloneData(this.filterData);

            Object.keys(filterData).forEach((key) => {
                let value = filterData[key];

                if (value === '' || value === null || value === undefined || (Array.isArray(value) && !value.length)) {
                    delete filterData[key];
                }
            });

            this.$emit('onFilter', filterData);
        },
        translateTitle(record) {
            return this.resolveDatum(record.translations, this.$root.defaultLanguage.id, 'language_id').title;
        },
        branchCourseTitle(branchCourse) {
            return branchCourse.title + (branchCourse.branch ? ' (' + branchCourse.branch.title + ')' : '');
        },
        secondToMinute(value) {
            return (value === '' || value === null || value === undefined) ? '' : Math.floor(value / 60);
        },
        setMinuteAsSecond(key, value) {
            if (value === '' || value === null || value === undefined) {
                delete this.filterData[key];
                return;
            }

            this.filterData[key] = parseInt(value) * 60;
        },
        disabledRangeMinDate(date, maxKey, allowFuture = true) {
            if (!allowFuture && date.getTime() > Date.now()) {
                return true;
            }

            const maxDate = this.filterData[maxKey] ? this.$moment(this.filterData[maxKey]) : undefined;

            return maxDate == undefined ? false : this.$moment(date).valueOf() > maxDate.valueOf();
        },
        disabledRangeMaxDate(date, minKey, allowFuture = true) {
            if (!allowFuture && date.getTime() > Date.now()) {
                return true;
            }

            const minDate = this.filterData[minKey] ? this.$moment(this.filterData[minKey]) : undefined;

            return minDate == undefined ? false : minDate.valueOf() > this.$moment(date).valueOf();
        },
        remoteSearch(stateKey, query, request) {
            query = (query ?? '').trim();

            clearTimeout(this.searchTimers[stateKey]);

            if (query.length < 2) {
                this[stateKey].loading = false;
                this[stateKey].list = [];
                return;
            }

            this[stateKey].loading = true;

            this.searchTimers[stateKey] = setTimeout(() => {
                request(query).then(response => {
                    this[stateKey].list = response.data.data;
                }).finally(() => {
                    this[stateKey].loading = false;
                });
            }, 400);
        },
        remoteSearchProduct(query) {
            this.remoteSearch('product', query, (search) => {
                return this.axios.get(this.endpoints['ecommerce_product'], {
                    params: {
                        title: search,
                        page_limit: 20
                    }
                });
            });
        },
        remoteSearchProductCategory(query) {
            this.remoteSearch('productCategory', query, (search) => {
                return this.axios.get(this.endpoints['ecommerce_product_category'], {
                    params: {
                        title: search,
                        page_limit: 20
                    }
                });
            });
        },
        disabledDate(date) {
            return date.getTime() > Date.now()
        },
        disabledCreatedMinDate(startDate) {
            startDate = this.$moment(startDate);
            const endDate = this.filterData['created_at[max]'] ? this.$moment(this.filterData['created_at[max]']) : undefined;

            return endDate == undefined ? false : startDate.valueOf() > endDate.valueOf()
        },
        disabledCreatedMaxDate(endDate) {
            endDate = this.$moment(endDate);
            const startDate = this.filterData['created_at[min]'] ? this.$moment(this.filterData['created_at[min]']) : undefined;

            return startDate == undefined ? false : startDate.valueOf() > endDate.valueOf();
        },
        addressStateChanged() {
            delete this.filterData.city_id;
            this.loadAddressCities();
        },
        loadAddressCities() {
            this.addressCities = [];

            if (!this.filterData.state_id) {
                return;
            }

            if (typeof this.filterData.state_id == 'string') {
                this.filterData.state_id = parseInt(this.filterData.state_id);
            }

            if (typeof this.filterData.city_id == 'string') {
                this.filterData.city_id = parseInt(this.filterData.city_id);
            }

            let foundIndex = this.stateWithCities.findIndex(state => state.id == this.filterData.state_id);

            if (foundIndex >= 0) {
                this.addressCities = this.cloneData(this.stateWithCities[foundIndex].cities ?? []);
            }
        },
        stateChanged(stateInputName) {
            this.cities = [];
            let cities = document.querySelectorAll(".citySelect");
            cities.forEach((cityElement) => {
                let inputName = cityElement.getAttribute('data-inputName');
                delete this.filterData[inputName];
            })

            if (this.filterData[stateInputName]) {
                let foundIndex = this.stateWithCities.findIndex(state => state.name == this.filterData[stateInputName]);

                if(foundIndex >= 0) {
                    this.cities = this.cloneData(this.stateWithCities[foundIndex].cities);
                }
            }
        }
    },
    watch: {
        'filterData.state_id'() {
            this.loadAddressCities();
        },
        stateWithCities() {
            this.loadAddressCities();
        }
    }
}
</script>

<style>

</style>